import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import Menu from '../../../components/Layout/Menu';

import Nav from './Nav';

import logomarca from '../../../assets/images/logomarca.png';

import './styles.css';

export default function Header({flag}) {

    const handleScroll = () => {
        const element  = document.querySelector('#header');

        window.addEventListener('scroll', function() {
            if (window.pageYOffset > 30) {
                element.classList.add('show-header');
            } else {
                element.classList.remove('show-header');
            }
        })
    }

    const openDrawer = () => {
        document.querySelector('#drawer-menu').classList.remove('no-drawer-menu');
        document.querySelector('#drawer-menu-overlay').classList.remove('no-overlay');
    }
       
    useEffect(() => { handleScroll() },[]);

    return (
        <header id="header">
            <div className="container">
                <div className="logomarca">
                    <Link to='/'><img src={logomarca} alt={process.env.REACT_APP_NAME}/></Link>
                </div>

                <Nav />
                <span className="btn-menu" onClick={openDrawer}>
                    <FiMenu size={18} />&nbsp;
                    Menu
                </span>
                <Menu />
            </div>
        </header>
    );
}